import React from 'react';

import GroupLinks from '../../../GroupLinks';
import { CustomLink } from '../../../index';
import { CREATIVE_HUB_SUB_LINKS, LINKS, RESOURCES_SUB_LINKS } from '../../constants';
import { NavMenu } from '../../styled';

const PublicMenu = (): JSX.Element => (
  <NavMenu data-testid="publicHeaderNav">
    <CustomLink link={LINKS.successStories} text="success stories" />
    <GroupLinks mainLink={LINKS.resources} subLinks={RESOURCES_SUB_LINKS} text="Resources" />
    <GroupLinks mainLink={LINKS.creativeHub} subLinks={CREATIVE_HUB_SUB_LINKS} text="Creative Hub" />
    <CustomLink link={LINKS.newsEvents} text="News & Events" />
    <CustomLink link={LINKS.FAQ} text="FAQ" />
  </NavMenu>
);

export default PublicMenu;
